import React, { useState, useEffect } from 'react'
import { DevicePhoneMobileIcon } from '@heroicons/react/24/outline'

export const PWAInstallPrompt: React.FC = () => {
  const [installPrompt, setInstallPrompt] = useState<any>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [showAnimation, setShowAnimation] = useState(false)

  useEffect(() => {
    const checkPWAInstallAvailability = () => {
      // Check if the app is already installed
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true

      // Detect mobile devices
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

      // Check if PWA installation is supported
      const isPWASupported = 'beforeinstallprompt' in window

      return !isStandalone && isMobile && isPWASupported
    }

    const handleBeforeInstallPrompt = (e: any) => {
      e.preventDefault()
      setInstallPrompt(e)
      
      // Only show if conditions are met
      if (checkPWAInstallAvailability()) {
        setTimeout(() => {
          setIsVisible(true)
          setTimeout(() => setShowAnimation(true), 100)
        }, 2000)
      }
    }

    // Add event listener for install prompt
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)

    // Initial check
    if (checkPWAInstallAvailability()) {
      setIsVisible(true)
      setTimeout(() => setShowAnimation(true), 2000)
    }

    // Cleanup
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    }
  }, [])

  const handleInstall = async () => {
    if (installPrompt) {
      try {
        // Prompt the user to install
        const result = await installPrompt.prompt()
        const choiceResult = await installPrompt.userChoice

        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt')
          setIsVisible(false)
          setShowAnimation(false)
        } else {
          console.log('User dismissed the install prompt')
          localStorage.setItem('pwa-install-dismissed', 'true')
          setIsVisible(false)
          setShowAnimation(false)
        }
      } catch (error) {
        console.error('Error showing install prompt:', error)
      }
    }
  }

  const handleDismiss = () => {
    setShowAnimation(false)
    setTimeout(() => {
      setIsVisible(false)
    }, 300)
    localStorage.setItem('pwa-install-dismissed', 'true')
  }

  if (!isVisible) return null

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out 
      ${showAnimation ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="bg-brand-600 text-white p-4 shadow-xl flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <DevicePhoneMobileIcon className="h-8 w-8" />
          <div>
            <p className="font-bold">Install A&H Home Buyer Calculator</p>
            <p className="text-sm">Get quick access to home buying tools</p>
          </div>
        </div>
        <div className="flex space-x-2">
          <button 
            onClick={handleInstall}
            className="bg-white text-brand-600 px-4 py-2 rounded-md font-semibold hover:bg-brand-50 transition"
          >
            Install
          </button>
          <button 
            onClick={handleDismiss}
            className="text-white hover:bg-brand-500 px-2 py-2 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
